import { usePageContext } from '../../../../context.js';
import { useMatchTaskBreakpoint, taskBreakpoints } from '../../hook.task-breakpoints.js';
import { wrapper } from './_task.checkbox.style.js';
import { AudioInput } from './input.audio.js';
import { ImageInput } from './input.image.js';
import { TextInput } from './input.text.js';
import { VideoInput } from './input.video.js';
import { jsx } from 'react/jsx-runtime';

function SelectAnswersCheckboxTask(props) {
  const pageContext = usePageContext();
  const isMobile = useMatchTaskBreakpoint(taskBreakpoints.mobile);
  const isOnlyTextInputs = props.task.content.every(it => it.type === "Text");
  const orientation = isMobile || props.task.settings.orientation === "Vertical" && pageContext !== "print" ? "vertical" : "horisontal";
  return /*#__PURE__*/jsx("div", {
    className: wrapper,
    "data-orientation": orientation,
    "data-text-only": isOnlyTextInputs,
    "data-page-context": pageContext,
    children: props.task.content.map(it => {
      switch (it.type) {
        case "Text":
          return /*#__PURE__*/jsx(TextInput, {
            taskEntryKey: props.taskEntryKey,
            node: it,
            orientation: orientation
          }, it.id);
        case "Image":
          return /*#__PURE__*/jsx(ImageInput, {
            taskEntryKey: props.taskEntryKey,
            node: it,
            orientation: orientation
          }, it.id);
        case "InlineAudio":
          return /*#__PURE__*/jsx(AudioInput, {
            taskEntryKey: props.taskEntryKey,
            node: it,
            orientation: orientation
          }, it.id);
        case "Video":
          return /*#__PURE__*/jsx(VideoInput, {
            taskEntryKey: props.taskEntryKey,
            node: it,
            orientation: orientation
          }, it.id);
        default:
          return null;
      }
    })
  });
}

export { SelectAnswersCheckboxTask };
//# sourceMappingURL=_task.checkbox.js.map
